export default "__VITE_ASSET__CFRkAf4I__"